"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _LoadingModule = _interopRequireDefault(require("./../../scss/utils/Loading.module.scss"));
function Loading({
  spinnerColor = 'var(--theme-color-100)',
  spinnerSize = '3.125rem',
  spinnerTrackWidth = '6px',
  topOffset = '50%',
  message = ''
}) {
  return /*#__PURE__*/_react.default.createElement("loading-wrapper", {
    style: {
      '--spinner-size': spinnerSize,
      '--spinner-track-width': spinnerTrackWidth,
      '--spinner-color': spinnerColor,
      '--spinner-top-offset': topOffset
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LoadingModule.default['spinner-wrap'],
    "data-state": "entering"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LoadingModule.default['spinner']
  })), message !== '' && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_LoadingModule.default['loading-wrapper__message'], 'loading-wrapper__message'])
  }, message));
}
var _default = exports.default = Loading;